import { print } from 'graphql';

import removeByIdCategoryMutation from '~/shared/graphql-queries/categories/remove-by-id-category-mutation';
import updateByIdCategoryMutation from '~/shared/graphql-queries/categories/update-by-id-category-mutation';
import type { BuilderType } from '~/types';

type RemoveByIdCategoryArgs = Readonly<{
  _id?: string;
}>;

type UpdateByIdCategoryArgs = Readonly<{
  _id?: string;
  record?: Record<string, unknown>;
}>;

export const categoriesTagTypes = ['categories'] as const;

export const getCategoriesQuery = (builder: BuilderType) => {
  return {
    removeByIdCategory: builder.mutation<unknown, RemoveByIdCategoryArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdCategoryMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),

    updateByIdCategory: builder.mutation<unknown, UpdateByIdCategoryArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(updateByIdCategoryMutation),
          variables: {
            _id: args?._id,
            record: args?.record,
          },
        }),
      }),
    }),
  };
};
